import { StrictMode, useEffect } from 'react';

import { getEvelinOrderIdStorage, getPaypalOrderIdStorage } from '@jsmdg/browser-storage';
import { OverlayProvider } from '../providers';
import { ProductDetail } from './ProductDetail';

const ProductDetailWrapper = (): JSX.Element => {
    useEffect(() => {
        getPaypalOrderIdStorage().remove();
        getEvelinOrderIdStorage().remove();
    }, []);

    return (
        <StrictMode>
            <OverlayProvider>
                <ProductDetail />
            </OverlayProvider>
        </StrictMode>
    );
};

export { ProductDetailWrapper };
